import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm, NgModel } from '@angular/forms';
import { LookUpService } from '../../../services/lookupservice';
import { FeedstockService } from '../../../services/feedstockservice';
import {
  AttachDocumentsDialogData,
  DockTypesResponse,
} from '../../../interfaces/sitelockcodes';
import { siteAttachDocumentsDialogData } from '../../../interfaces/siteAttachDocumentsDialogData';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-attach-documents',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    DragDropModule
  ],
  templateUrl: './attach-documents.component.html',
  styleUrl: './attach-documents.component.scss',
})
export class AttachDocumentsComponent implements OnInit {
  @ViewChild('attachDocForm') attachDocForm!: NgForm;
  @ViewChild('docTypeInput') docTypeInput!: NgModel;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  docTypes: DockTypesResponse[] = [];
  selectedFiles: File[] = [];
  isUploadEnabled: boolean = false;
  //screenTypeId: number = 0;
  siteId: number = 0;
  docTypeId: number | null = null;
  allowedExtensions = ['.pdf'];
  dialogTitle = '';

  constructor(
    public dialogRef: MatDialogRef<AttachDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: siteAttachDocumentsDialogData,
    private lookUpService: LookUpService,
    private feedstockService: FeedstockService
  ) {
    console.log('attachments', data);
    this.siteId = data.sid;
    console.log('siteId', this.siteId, data);
    //this.screenTypeId = data.screenTypeId;
    this.dialogTitle = `Attach Document: ${data.siteName}`;
  }

  ngOnInit(): void {
    this.getFeedstockDocTypes();
  }

  getFeedstockDocTypes(): void {
    this.lookUpService.getDocTypeByScreenType(2).subscribe({
      next: (data: DockTypesResponse[]) => {
        this.docTypes = data;
        this.docTypeId = null;
      },
    });
  }

  onDocTypeChange(): void {
    this.isUploadEnabled = this.docTypeId !== null;

    if (!this.isUploadEnabled && this.fileInput) {
      this.fileInput.nativeElement.value = '';

      // ✅ Reset to empty array (NOT null)
      this.selectedFiles = [];

      const loadSlipFilesControl =
        this.attachDocForm?.controls?.['loadSlipFiles'];

      if (loadSlipFilesControl) {
        loadSlipFilesControl.setErrors(null);
        loadSlipFilesControl.markAsPristine();
        loadSlipFilesControl.markAsUntouched();
      }
    }
  }


  onFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      return;
    }

    this.processFiles(Array.from(input.files));

    // Reset so same file can be selected again
    input.value = '';
  }
  private processFiles(newFiles: File[]): void {

    const control = this.attachDocForm?.controls?.['loadSlipFiles'];

    if (!control) {
      return;
    }

    // Validate document type
    if (!this.docTypeId) {
      this.attachDocForm.controls['docTypeId']
        ?.setErrors({ required: true });
      return;
    }

    // Validate extensions
    const invalidFiles = newFiles.filter(file => {
      const ext = '.' + file.name.split('.').pop()?.toLowerCase();
      return !this.allowedExtensions.includes(ext);
    });

    if (invalidFiles.length > 0) {
      control.setErrors({ invalidFileType: true });
      return;
    }

    // Append files
    this.selectedFiles = [
      ...this.selectedFiles,
      ...newFiles
    ];

    control.setErrors(null);
    control.markAsTouched();
  }

  removeFile(file: File): void {
    this.selectedFiles = this.selectedFiles.filter(f => f !== file);

    if (this.selectedFiles.length === 0) {
      this.attachDocForm.controls['loadSlipFiles']?.setErrors({ required: true });
    }
  }

  onUploadDocument(): void {
    this.attachDocForm.form.markAllAsTouched();
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      this.attachDocForm.controls['loadSlipFiles'].setErrors({
        required: true,
      });
      this.attachDocForm.controls['loadSlipFiles'].markAsTouched();
    }

    if (
      this.attachDocForm.invalid ||
      !this.selectedFiles ||
      this.selectedFiles.length === 0
    ) {
      this.attachDocForm.form.markAllAsTouched();
      return;
    }

    const formData = new FormData();
    formData.append('loadScheduleId', this.siteId!.toString());
    formData.append('docTypeId', this.docTypeId!.toString());
    formData.append('screenTypeId', '2');

    for (let i = 0; i < this.selectedFiles.length; i++) {
      formData.append(
        'files',
        this.selectedFiles[i],
        this.selectedFiles[i].name
      );
    }

    this.feedstockService.uploadLoadDocument(formData).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
    });
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();   // Allow dropping
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();

    if (!event.dataTransfer?.files?.length) {
      return;
    }

    this.processFiles(Array.from(event.dataTransfer.files));
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  trackById(index: number, item: DockTypesResponse): number {
    return item.id;
  }
}
